import * as React from 'react';
import MUIButton, { ButtonProps } from '@material-ui/core/Button';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

type OwnProps = {
  isSubmitting?: boolean;
  isDisabled?: boolean;
};

type Props = OwnProps & ButtonProps;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: ({ color }: Props) => ({
      '&:disabled': {
        backgroundColor: theme.palette[color || 'primary'].main
      }
    }),
    label: {
      color: theme.palette.common.white
    }
  })
);

export const LoadingButton = ({ children, disabled, isSubmitting, isDisabled, ...props }: Props) => {
  const styles = useStyles(props);

  return (
    <MUIButton {...props} classes={isSubmitting ? styles : {}} disabled={isSubmitting || isDisabled}>
      {children}
    </MUIButton>
  );
};
